import { BaseDTO } from '../global/base.dto';
import { ResourceListDTO } from '../resource/resource-list.dto';
import { TeamListDTO } from '../team/team-list.dto';

export class ResourceGroupDTO extends BaseDTO {

    name: string;

    description: string;

    resources: Array<ResourceListDTO>;

    teams: Array<TeamListDTO>;

}
